<template>
    <div class="">
        <v-card flat class="d-flex justify-center mt-15">
            <v-card flat tile>
                <v-card-text class="text-center">
                    <v-avatar size="135">
                        <img
                        src="/img/claf.jpg"
                        >
                    </v-avatar>
                    <p class="text-h4 font-weight-bold">
                        {{$t('noRecordFound')}}
                    </p>
                    <p>
                        {{$t('animal.healthRecordInfo.animalNoHealthRecord')}}
                    </p>
                    <div class="text-center">
                        <v-btn
                            rounded
                            color="primary"
                            width="239"
                            height="38"
                            :to="{ name: 'AnimalHealthReordEdit', params: {animal_number: $route.params.animal_number}}"
                        >
                            {{$t('animal.healthRecordInfo.addHealthRecord')}}
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-card>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>

</style>